import type { ParsedData } from '../types';
import { parseNERJson } from './fileParser';

/**
 * BQ-22: Fetch the bundled `/example-data.json` and parse it through the
 * existing JSON loader. Used by the LandingPage's "Try sample data" CTA so
 * a first-time visitor can populate the workspace with one click and play
 * with every feature without preparing their own file.
 *
 * No caching here — this is a one-shot user action; if it ever became hot
 * we'd add it, but right now an extra fetch on click is cheaper than the
 * cognitive overhead of cache invalidation.
 */
export async function loadSampleData(): Promise<ParsedData> {
  const res = await fetch('/example-data.json');
  if (!res.ok) {
    throw new Error(`Failed to load sample data (${res.status})`);
  }
  const text = await res.text();
  return parseNERJson(text);
}
